/**
 * The SKJV per-namespace disk layout for LocalDiskProvider — the one place
 * that says how study records land on the user's filesystem:
 *
 *   studies/Mat-2_21-29_my-title/Mat-2_21-29_my-title.json   (the envelope — source of truth)
 *   studies/Mat-2_21-29_my-title/Mat-2_21-29_my-title.md     (derived, human-inspectable)
 *
 * Files carry the folder's name so each stays self-identifying even copied
 * out of its folder. Folder names come from the envelope's `displayName`
 * (recomputed from studyFolderName on every save); the provider itself stays
 * product-agnostic. Shared by the desktop shell (user-store) and CLI tooling
 * (retrofit script) so on-disk layout can never drift between writers.
 */
import { studyMarkdownFromEnvelope } from './study-markdown.js';
export function studyRecordFileName(folder) {
    return `${folder}.json`;
}
export function studyMarkdownFileName(folder) {
    return `${folder}.md`;
}
export function skjvDiskLayouts() {
    return {
        studies: {
            recordFileName: studyRecordFileName,
            folderName: (document) => document?.displayName ?? null,
            documentKey: (document) => document?.key ?? null,
            // Newest envelope wins when duplicate folders claim one study id —
            // ISO timestamps compare lexicographically (fork heal, 2026-09-04).
            documentOrder: (document) => document?.updatedAt ?? '',
            renderSidecars: (document, folder) => {
                const markdown = studyMarkdownFromEnvelope(document);
                return markdown ? [{ name: studyMarkdownFileName(folder), content: markdown }] : [];
            },
        },
    };
}
//# sourceMappingURL=disk-layout.js.map